import React, { useEffect, useRef, useState } from "react";
import "./Message.scss";
import { Tab, Tabs } from "react-bootstrap";
import { avatar, img_placehlder, msg_list } from "../../../assets";
import { CiSearch } from "react-icons/ci";
import { socket } from "../../../utils/socket";
import moment from "moment";
import useDebounce from "../../../hooks/useDebounce";
import { GiHamburgerMenu } from "react-icons/gi";
import { RxCrossCircled } from "react-icons/rx";
import { useNavigate } from "react-router";

const ChatList = ({
  selectedChatType,
  setSelectedChatType,
  setSelectedChat,
  groupDetails,
  setGroupDetails,
  setMemberDetails,
  chatId,
  tab,
  onClick,
  selectedChat,
  setIsReplay,
  setSelectReplyData,

  chatType,
  attachment,
  setAttachment,
  inputData,
  setInputData,
}) => {
  const [chatList, setChatList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastChatId, setLastChatId] = useState(null);
  const [search, setSearch] = useState({});
  const debouncedValue = useDebounce(search, 300);
  const sidebarListRef = useRef(null);
  const [totalPages, setTotalPages] = useState(null);
  const navigate = useNavigate();

  // console.log('selectedChatType', selectedChatType)
  // const tabsName = chatType === 'GROUP' ? "Group Chat..." : chatType === 'MEMBER' ? 'Member Chat...' : 'chat'
  //   Receive Chat List
  const receiveChatList = (data) => {
    // console.log("receive Chat List", data);
    const { success, data: chat, meta } = data;
    if (success) {
      setChatList(chat || []);
      setTotalPages(meta?.totalPages);
      if (!chatId) {
        setSelectedChat(chat?.[0]?._chat);
        setLastChatId(chat?.[0]?._chat);
      }
      // scrollToBottom(meta?.page);
    }
  };
  //--------chaiId-find------------------
  useEffect(() => {
    if (chatId) {
      // console.log('chaiId-find', chatId)
      const findChatData = chatList.find((data) => data?._chat?._id === chatId);
      setSelectedChat(findChatData?._chat);
      setLastChatId(findChatData?._chat);
    }
  }, [chatList, chatId]);

  // Receive Chat List
  useEffect(() => {
    socket.on("RECEIVE_CHAT_LIST", receiveChatList);
    return () => {
      socket.off("RECEIVE_CHAT_LIST");
      setCurrentPage(1);
    };
  }, []);

  useEffect(() => {
    socket.emit("REQUEST_CHAT_LIST", {
      page: 1 || currentPage,
      limit: 10000000,
      search: debouncedValue,
      type: chatType, // selectedChatType,
    });

    if (!debouncedValue) {
      setMemberDetails("");
    }
  }, [chatType, debouncedValue]); //selectedChatType

  useEffect(() => {
    setSearch("");
    setCurrentPage(1);
    // if(chatId){

    // }
  }, [chatType]); //selectedChatType

  const handleExit = (item) => {
    socket.emit("REQUEST_LEAVE_ROOM", {
      _chat: lastChatId,
    });
    setLastChatId(item);
  };

  // const scrollToBottom = (page) => {
  //   const chatContainer = sidebarListRef.current;
  //   if (chatContainer) {
  //     const currentScrollHeight = chatContainer.scrollHeight;
  //     setTimeout(() => {
  //       if
  //         (page === 1) {
  //         // chatContainer.scrollBottom = 0;
  //         chatContainer.scrollTop =
  //           chatContainer.scrollHeight - currentScrollHeight;
  //       } else {
  //       }
  //       // chatContainer.scrollTop =
  //       //   chatContainer.scrollHeight - currentScrollHeight;
  //       chatContainer.scrollBottom = 0;

  //     }, 0);
  //   }
  // };

  //   Load More older message
  // const loadMoreMessages = () => {
  //   const chatContainer = sidebarListRef.current;
  //   if (chatContainer.scrollTop === 0 && totalPages > currentPage) {
  //     receiveChatList(currentPage + 1);
  //     setCurrentPage((prev) => prev + 1);
  //   }
  // };
  //-------reset-search-page-when-tab-change-----------

  //-------------handle-Member-Search---------------
  const handleMemberSearchData = (id, user) => {
    // console.log('user id', id)
    if (id) {
      setMemberDetails(user);
      socket.emit("REQUEST_USER_DETAIL", {
        _user: id,
      });
    }
  };

  useEffect(() => {
    socket.on("RECEIVE_USER_DETAIL", receiveSearchMemberData);

    return () => {
      socket.off("RECEIVE_USER_DETAIL");
      setCurrentPage(1);
    };
  }, []);

  const addToChat = (_user) => {
    socket.emit('REQUEST_USER_DETAIL', {
      _user
    })
  }

  const receiveSearchMemberData = (data) => {
    // setSearch("");

    console.log({data});
    
    setTimeout(() => {
      if (data?.success) {
        const user = data?.data?.participant;
        let chat = data?.data?._chat;
        chat = { ...chat, chatParticipants: { ...chat?.chatParticipants, _user: user } }
        setSelectedChat({ ...chat, chatExist: true });
      } else {
        setSelectedChat(data?.data);
      }
    }, 1 * 500);

  };
  // --------click-side-bar---------------------
  const handleChatClick = (chat, type) => {
    setSelectedChat(chat);
    handleExit(chat);
    setIsReplay(false);
    setSelectReplyData({});
    setAttachment({ attachment: "", type: "", url: "" });
    setInputData({ message: "", type: "" });

    if (chatId) {
      if (type === "GROUP") {
        navigate("/dashboard/message/group");
      } else if (type === "MEMBER") {
        navigate("/dashboard/message/member");
      }
    }
  };

  // useEffect
  return (
    // <div className="msg_list_sidebar " >
    <div className="msg_list_sidebar">
      <button className="crossbtn" onClick={onClick}>
        <RxCrossCircled />
      </button>
      <div className="search_bar">
        <input
          type="text"
          className="search_input"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          placeholder="Search here"
        />
        <CiSearch className="search_icon" />
      </div>
      {/* <div className="msg-chat-list"> */}
      <div
        className="msg-chat-list"
      // ref={sidebarListRef}
      // onScroll={loadMoreMessages}
      >
        {chatType === "GROUP" ? (
          chatList && chatList.length > 0 ? (
            chatList.map((data, ind) => (
              <div
                key={ind}
                className={`chat-item ${data?._chat?._id === selectedChat?._id ? "active" : ""
                  }`}
                onClick={() => handleChatClick(data?._chat, "GROUP")}
              >
                <div className="chat-avatar">
                  <img
                    src={data?._chat?._group?.coverImage || avatar}
                    alt="Mindful Movers"
                  />
                </div>
                <div className="chat-details">
                  <p className="chat-title">
                    {data?._chat?._group?.name || ""}
                  </p>
                  <span>
                    {data?._chat?._group?._parent?.name || data?._chat?._group?.categoryName}
                  </span>
                  {data?._chat?.lastMessage?._sender?.fullName && (
                    <p className="chat-subtitle">
                      {data?._chat?.lastMessage?._sender?.fullName} :{" "}
                      {data?._chat?.lastMessage?.type === "TEXT"
                        ? (data?._chat?.lastMessage?.message || "")?.slice(
                          0,
                          10
                        )
                        : data?._chat?.lastMessage?.type === "MEDIA"
                          ? "Image"
                          : ""}
                    </p>
                  )}
                </div>
                <p className="chat-time">
                  {data?._chat?.lastMessage?.createdAt
                    ? moment(data?._chat?.lastMessage?.createdAt).fromNow()
                    : ""}
                </p>
              </div>
            ))
          ) : (
            <p className="text-center mt-3">No Group Found</p>
          )
        ) : chatType === "MEMBER" ? (
          chatList && chatList.length > 0 ? (
            chatList.map((data, ind) => {
              if (data?._chat) {
                return <div
                  key={ind}
                  className={`chat-item ${selectedChat?._id === data?._chat?._id && 'active'}`}
                  onClick={() => handleChatClick(data?._chat, "MEMBER")}
                >
                  <div className="chat-avatar">
                    <img
                      src={
                        data?._user?.profilePicture ||
                        data?._chat?.chatParticipants?._user?.profilePicture ||
                        avatar
                      }
                      alt="Mindful Movers"
                    />
                  </div>
                  <div className="chat-details">
                    <p className="chat-title">
                      {data?._user?.fullName ||
                        data?._chat?.chatParticipants?._user?.fullName}
                    </p>
                    {/* {(data?._chat?.chatParticipants?.groupMember?.group?.name ||
                      data?._group?.name) && (
                        <p className="chat-subtitle">
                          Group:{" "}
                          {data?._chat?.chatParticipants?.groupMember?.group
                            ?.name || data?._group?.name}
                        </p>
                      )} */}
                  </div>
                  <p className="chat-time">
                    {data?._chat?.lastMessage?.createdAt &&
                      moment(data?._chat?.lastMessage?.createdAt).fromNow()}
                  </p>
                </div>
              } else {
                const user = data?._user;
                return <div
                  key={data._id}
                  className={`chat-item ${(data?._user?._id === selectedChat?._user || data?._user?._id === selectedChat?.chatParticipants?._user?._id ) ? "active" : ""}`}
                  onClick={() => {
                    addToChat(user?._id)
                  }}
                >
                  <div className="chat-avatar">
                    <img src={user?.profilePicture ? user?.profilePicture : avatar} alt="Mindful Movers" />
                  </div>
                  <div className="chat-details">
                    <p className="chat-title">{user?.fullName}</p>
                  </div>
                </div>
              }

            })
          ) : (
            <p className="text-center mt-3">No Member Found</p>
          )
        ) : null}

      </div>
    </div>
  );
};

export default ChatList;
